import { getToken } from './tokenManager';

/**
 * Resolve a download filename from a socket/export event, URL path, or fallback.
 * Strips directory prefixes like "exports/...".
 *
 * @param {object|null|undefined} event
 * @param {string} [url='']
 * @param {string} [fallbackFilename='download.csv']
 * @returns {string}
 */
export function getDownloadFilename(event, url = '', fallbackFilename = 'download.csv') {
	const fromEvent =event?.filename || event?.data?.filename || event?.file_name || event?.data?.file_name || '';

	const fromUrl = (() => {
		if (!url) return '';
		try {
			const pathname = new URL(url, window.location.origin).pathname;
			return pathname.split('/').filter(Boolean).pop() || '';
		} catch (e) {
			return String(url).split('?')[0].split('/').filter(Boolean).pop() || '';
		}
	})();

	const raw = fromEvent || fromUrl || fallbackFilename;
	return String(raw).split('/').filter(Boolean).pop() || fallbackFilename;
}

/**
 * Download a file from a URL using Bearer auth (fetch + blob).
 * Use this instead of window.location.href when the download endpoint requires auth.
 *
 * @param {string} url
 * @param {string} [fallbackFilename='download.csv']
 */
export async function downloadFileWithAuth(url, fallbackFilename = 'download.csv') {
	const token = getToken();
	if (!url) {
		throw new Error('Download URL is missing');
	}
	if (!token) {
		throw new Error('Authentication token not found');
	}

	const response = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	if (!response.ok) {
		throw new Error(`Download failed with status ${response.status}`);
	}

	const blob = await response.blob();
	const contentDisposition = response.headers.get('Content-Disposition');
	const filenameMatch = contentDisposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
	const filename = filenameMatch?.[1]
		? filenameMatch[1].replace(/['"]/g, '')
		: fallbackFilename;

	const objectUrl = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = objectUrl;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	link.remove();
	URL.revokeObjectURL(objectUrl);
}
